import React from 'react';
import { EditButton } from "./Button";
import DataRow, { DataRowProps } from "./DataRow";
var DataPreview = function (_a) {
    var data = _a.data, editButtonLabel = _a.editButtonLabel, editButtonHandler = _a.editButtonHandler, placeholder = _a.placeholder;
    return (React.createElement("div", null,
        data.map(function (_a) {
            var label = _a.label, value = _a.value;
            return (React.createElement(DataRow, { key: label, label: label, value: value, placeholder: placeholder }));
        }),
        editButtonHandler && React.createElement(EditButton, { label: editButtonLabel, onClick: editButtonHandler })));
};
export default DataPreview;
//# sourceMappingURL=DataPreview.js.map